import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useLazyGetAnswersQuery } from "api";
import { OBJ_COLOR } from "commons/constants";
import { Answer } from "models";
import moment from "moment";
import { useState } from "react";
import * as XLSX from "xlsx";

export const ExportDataUsers = () => {
	const [getAnswers] = useLazyGetAnswersQuery();
	const [isLoading, setIsLoading] = useState(false);

	const handleOnClickExportData = async () => {
		let dataExcel: Answer[] = [];
		setIsLoading(true);
		await Promise.all(
			Array(99)
				.fill(10)
				.map(async (_, index) => {
					const result = await getAnswers({ pageSize: 5000, pageNumber: index + 1 }).unwrap();
					if (result.length > 0) {
						dataExcel = [...dataExcel, ...result];
					}
				})
		);

		// const Heading = [{ stt: "Stt", userId: "Mã số nhân viên", name: "Tên", email: "Email", stt_question: "STT Câu hỏi", type: "Phân mục", question: "Câu hỏi", answer: "Câu trả lời" }];
		const Heading = [{ stt: "STT", userId: "Key", stt_question: "STT Câu hỏi", type: "Phân mục", question: "Câu hỏi", answer: "Câu trả lời" }];
		const wscols = [{ wch: 6 }, { wch: 26 }, { wch: 12 }, { wch: 99 }, { wch: 120 }, { wch: 32 }];
		const header: any[] = [];

		let count = 0;
		const arr: string[] = [];

		const dataExport: any[] = [];

		dataExcel
			.sort((a, b) => a.id - b.id)
			.forEach((item, index) => {
				let stt = index;

				if (!arr.includes(item.userId)) {
					count = 1;
					arr.push(item.userId);
					item.preSurvey.forEach((pre) => {
						stt += 1;

						dataExport.push({
							stt,
							userId: item.userId,
							stt_question: 0,
							type: "PRE SURVEY",
							question: pre.question,
							answer: pre.answer,
						});
					});
				}

				stt += 1;

				dataExport.push({
					stt,
					userId: item.userId,
					stt_question: count++,
					type: item.question.category,
					question: item.question.question,
					answer: item.question.answer === "-" ? item.answer : item.question.answer.split("\n")[+item.answer],
				});
			});

		const worksheet = XLSX.utils.json_to_sheet(Heading, {
			header,
			skipHeader: true,
		});

		XLSX.utils.sheet_add_json(worksheet, dataExport || [], {
			header,
			skipHeader: true,
			origin: -1,
		});

		const workbook = XLSX.utils.book_new();

		XLSX.utils.book_append_sheet(workbook, worksheet, "data");

		worksheet["!cols"] = wscols;
		XLSX.writeFile(workbook, `${moment().format("YYYY-MM-DD")}-report-survey.xlsx`, { compression: true });
		setIsLoading(false);
	};
	// useEffect(() => {
	// 	if (!answers) return;

	// 	const Heading = [{ stt: "Stt", userId: "Mã số nhân viên", name: "Tên", email: "Email", stt_question: "STT Câu hỏi", type: "Phân mục", question: "Câu hỏi", answer: "Câu trả lời" }];
	// 	const wscols = [{ wch: 6 }, { wch: 10 }, { wch: 15 }, { wch: 15 }, { wch: 10 }, { wch: 15 }, { wch: 100 }, { wch: 20 }];
	// 	const header: any[] = [];

	// 	let count = 0;
	// 	const arr: string[] = [];

	// 	const dataExport = answers?.map((item, index) => {
	// 		if (!arr.includes(item.userId)) {
	// 			arr.push(item.userId);
	// 			count = 1;
	// 		}
	// 		return {
	// 			stt: index + 1,
	// 			userId: item.userId,
	// 			email: item.user.email,
	// 			name: item.user.name,
	// 			stt_question: count++,
	// 			type: item.question.category,
	// 			question: item.question.question,
	// 			answer: item.question.answer === "-" ? item.answer : item.question.answer.split("\n")[+item.answer],
	// 		};
	// 	});

	// 	const ws = XLSX.utils.json_to_sheet(Heading, {
	// 		header,
	// 		skipHeader: true,
	// 	});
	// 	ws["!cols"] = wscols;

	// 	XLSX.utils.sheet_add_json(ws, dataExport || [], {
	// 		header,
	// 		skipHeader: true,
	// 		origin: -1, //ok
	// 	});
	// 	const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
	// 	const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
	// 	const data = new Blob([excelBuffer], { type: fileType });
	// 	FileSaver.saveAs(data, "report-survey-2022" + fileExtension);
	// 	setIsLoading(false);
	// }, [answers]);

	return (
		<>
			<Button loading={isLoading} onClick={handleOnClickExportData} style={{ borderColor: OBJ_COLOR.INFO, color: OBJ_COLOR.INFO }} icon={<DownloadOutlined />}>
				Export answers
			</Button>
		</>
	);
};
